import StringValueObject from '@/domain/shared/strings/StringValueObject';

export default class TomReferenceCode extends StringValueObject {}
